interface TreeTheme {
  tree: {
    base: React.CSSProperties;
    node: {
      base: React.CSSProperties;
      customContainer: {
        node: React.CSSProperties;
        link: React.CSSProperties;
        activeLink: React.CSSProperties;
      };
      toggle: {
        base: React.CSSProperties;
      };
      header: {
        base: React.CSSProperties;
        connector: React.CSSProperties;
        title: React.CSSProperties;
        titleIcon: React.CSSProperties;
        titleText: React.CSSProperties;
        enableTitleText: React.CSSProperties;
        activeTitleText: React.CSSProperties;
      };
      subtree: React.CSSProperties;
      loading: React.CSSProperties;
    };
  };
}

const customTheme: TreeTheme = {
  tree: {
    base: {
      listStyle: "none",
      backgroundColor: "none",
      margin: 0,
      padding: "4px 0",
      color: "0",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      fontSize: "13px",
      overflow: "auto",
      minWidth: ""
    },
    node: {
      base: {
        position: "relative"
      },
      customContainer: {
        node: {
          paddingLeft: "20px",
          marginTop: "2px",
          marginBottom: "2px"
        },
        link: {
          cursor: "pointer",
          position: "relative",
          display: "block",
          padding: "8px 12px",
          borderRadius: "8px",
          transition: "all 0.2s ease",
          marginBottom: "3px",
          marginRight: "8px"
        },
        activeLink: {
          background: "rgba(103, 135, 248, 0.18)",
          borderLeft: "3px solid #6787f8",
          boxShadow: "0 2px 8px rgba(103, 135, 248, 0.15)"
        }
      },
      toggle: {
        base: {
          position: "absolute",
          left: "2px",
          lineHeight: "24px",
          fontSize: "12px",
          color: "rgba(255, 255, 255, 0.6)",
          transition: "transform 0.2s ease"
        }
      },
      header: {
        base: {
          color: "0"
        },
        connector: {
          width: "2px",
          height: "12px",
          borderLeft: "solid 2px rgba(103, 135, 248, 0.3)",
          borderBottom: "solid 2px rgba(103, 135, 248, 0.3)",
          position: "absolute",
          top: "0",
          left: "-20px"
        },
        title: {
          display: "flex",
          lineHeight: "1.6",
          marginTop: "0",
          alignItems: "center",
          padding: "2px 0",
          gap: "8px"
        },
        titleIcon: {
          marginRight: "8px",
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "20px"
        },
        titleText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: "500",
          letterSpacing: "0.01em"
        },
        enableTitleText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "#82b1ff",
          fontWeight: "500"
        },
        activeTitleText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "#6787f8",
          fontWeight: "600"
        }
      },
      subtree: {
        listStyle: "none",
        paddingLeft: "12px",
        marginTop: "2px",
        borderLeft: "1px solid rgba(103, 135, 248, 0.15)",
        marginLeft: "20px"
      },
      loading: {
        color: "#E2C089"
      }
    }
  }
};

export default customTheme;

